import { styled } from '@fv/design-tokens'

const TruncateText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export default TruncateText
